function hideImage(event) {
  event.currentTarget.style.display = "none";
}

export { hideImage };
